module.exports = __webpack_public_path__ + "static/media/Lucida Sans Unicode-01.df230423.svg";